import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Form,
  Button,
  Input,
  InputNumber,
  Modal,
  Select,
  DatePicker,
  Space,
} from "antd";

const SubmitButton = ({ form, children }) => {
  const [submittable, setSubmittable] = React.useState(false);
  // Watch all values
  const values = Form.useWatch([], form);
  React.useEffect(() => {
    form
      .validateFields({ validateOnly: true })
      .then(() => setSubmittable(true))
      .catch(() => setSubmittable(false));
  }, [form, values]);
  return (
    <Button type="primary" htmlType="submit" disabled={!submittable}>
      {children}
    </Button>
  );
};

function AddCampaign(props) {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleClose = () => {
    console.log("handleClose");
    setIsModalOpen(!isModalOpen);
    console.log("handleClose");
  };

  const handleOk = (values) => {
    console.log("handleOk");
    console.log("values: ", values);

    let r = (Math.random() + 1).toString(36).substring(7);

    let campaign_start_date_date_string = new Date(
      values.CampaignFlightStartDate[0]
    )
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");

    let campaign_end_date_date_string = new Date(
      values.CampaignFlightStartDate[1]
    )
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");

    const new_campaign = {
      index: r,
      CampaignId: values.CampaignId,
      CampaignFlightBudget: values.CampaignFlightBudget,
      CampaignFlightStartDate: values.CampaignFlightStartDate[0],
      CampaignFlightStartDateString: campaign_start_date_date_string + " 00:00:00",
      CampaignFlightEndDate: values.CampaignFlightStartDate[1],
      CampaignFlightEndDateString: campaign_end_date_date_string + " 00:00:00",
      GoalType: values.GoalType,
      GoalValue: 0,
      OutcomeNeeded: values.OutcomeNeeded,
      AdditionalEmails: values.AdditionalEmails,
    };
    props.saveCampaign(new_campaign);

    console.log("new_campaign:", new_campaign);
    setIsModalOpen(false);
    form.resetFields();
  };

  const validateEmails = (_, value) => {
    if (!value) {
      return Promise.resolve(); // Allow empty field if not required
    }

    const emails = value.split(",").map((email) => email.trim());
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const invalidEmails = emails.filter((email) => !emailRegex.test(email));

    if (invalidEmails.length > 0) {
      return Promise.reject(
        new Error(`Invalid email(s): ${invalidEmails.join(", ")}`)
      );
    }

    return Promise.resolve();
  };


  const layout = {
    labelCol: { span: 12 },
    wrapperCol: { span: 10 },
  };

  return (
    <div>
      <Button
        as="button"
        data-ttd-inspect-id="back-primary-button"
        className="btn-space"
        onClick={showModal}
      >
        Add Campaign
      </Button>
      <Modal
        open={isModalOpen}
        title="New Campaign"

        onCancel={handleClose}
        footer={<div></div>}
      >
        <Form
          {...layout}
          layout="horizontal"
          onFinish={handleOk}
          form={form}
          labelWrap={true}
        >
          <Form.Item
            name="CampaignId"
            label="CampaignId"
            rules={[{ required: true, message: "Missing CampaignId!" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="CampaignFlightBudget"
            label="Flight Media Budget"
            rules={[
              { required: true, message: "Missing Campaign Flight Budget!" },
            ]}
          >
            <InputNumber min={1}/>
          </Form.Item>

          <Form.Item
            name="CampaignFlightStartDate"
            label="Flight Start-End Date"
            rules={[
              { required: true, message: "Missing Flight Start-End Date!" },
            ]}
          >
            <DatePicker.RangePicker size="large" showSecond={false} />
          </Form.Item>

          <Form.Item
            name="GoalType"
            label="Goal Type (CPC / CPCV)"
            rules={[{ required: true, message: "Missing Goal Type!" }]}
          >
            <Select
              getPopupContainer={() => {}}
              options={[
                {
                  disabled: false,
                  label: "CPCV",
                  searchText: "CPCV",
                  value: "CPCV",
                },
                {
                  disabled: false,
                  label: "CPC",
                  searchText: "CPC",
                  value: "CPC",
                },
                {
                  disabled: false,
                  label: "CPL",
                  searchText: "CPL",
                  value: "CPL",
                },
              ]}
              placeholder="Select a Goal Type"
              size="full"
            />
          </Form.Item>

          <Form.Item
            name="OutcomeNeeded"
            label="Flight Outcome Goal (Clicks/ Completed Views, Completed Listens)"
            rules={[
              { required: true, message: "Missing Flight Outcome Goal!" },
            ]}
          >
            <InputNumber  min={1}/>
          </Form.Item>

          <Form.Item
            name="AdditionalEmails"
            label="Additonal Emails (optional, Comma separated list)"
            rules={[{ validator: validateEmails }]}
          >
            <Input />
          </Form.Item>
          <Form.Item>
            <Space>
              <SubmitButton form={form}>Submit</SubmitButton>
              <Button htmlType="reset">Reset</Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

AddCampaign.propTypes = {
  saveCampaign: PropTypes.func,
};

export default AddCampaign;
